var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ConciliationTable',{attrs:{"title":"Conciliados","fields":_vm.fields,"items":_vm.data,"disabled-values":true,"can-edit":false},on:{"removeItem":_vm.removeRow}})}
var staticRenderFns = []

export { render, staticRenderFns }